import {
  Component,
  input,
  signal,
  computed,
  effect,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatSliderModule } from '@angular/material/slider';

export interface RangeSliderChangeEvent {
  startId: number;
  endId: number;
}

@Component({
  imports: [MatSliderModule],
  selector: 'app-range-slider',
  templateUrl: './range-slider.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./range-slider.component.scss'],
})
export class RangeSliderComponent {
  points = input<Array<number>>([]);
  rangeChange = output<RangeSliderChangeEvent>();

  startIndex = signal(0);
  endIndex = signal(0);

  startId = computed(() => this.points()[this.startIndex()]);
  endId = computed(() => this.points()[this.endIndex()]);

  constructor() {
    effect(() => {
      const length = this.points().length;
      if (!length) return;

      this.startIndex.set(0);
      this.endIndex.set(length - 1);
    });

    // Emit changes
    effect(() => {
      if (!this.points().length) return;

      this.rangeChange.emit({
        startId: this.startId(),
        endId: this.endId(),
      });
    });
  }
}
